import React from "react";

function Footer() {
  return (
    <div className="bg-red-900 w-full h-32 p-12 shadow-footer text-white text-shadow-white">
      <p className="text-center">Portfolio 2023</p>
    </div>
  );
}

export default Footer;
